import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Home";
import Policy from "./Policy";
import DeleteAccount from "./DeleteAccount";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/policy" element={<Policy />} />
        <Route path="/delete_account" element={<DeleteAccount />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
